var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from "react";
import { DropdownItem, NavItem, NavLink } from "../..";
import classNames from "classnames"; // This code has been copied and modified from https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/modules/Link.js
// to better integrate react router with our Bootstrap Navbar

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

function createReactRouterProps(_a) {
  var navigate = _a.navigate,
      _onClick = _a.onClick,
      rest = __rest(_a, ["navigate", "onClick"]);

  return Object.assign(Object.assign({}, rest), {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !rest.target || rest.target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
        event.preventDefault();
        navigate();
      }
    }
  });
}

export var ReactRouterNavBarLink = forwardRef(function (_props, forwardedRef) {
  var children = _props.children,
      disabled = _props.disabled;
  var props = createReactRouterProps(_props);
  props.ref = forwardedRef;
  return React.createElement(NavItem, {
    className: props.className
  }, React.createElement(NavLink, Object.assign({
    disabled: disabled
  }, props), children));
});
export var ReactRouterDropDownLink = forwardRef(function (_props, forwardedRef) {
  var props = createReactRouterProps(_props);
  props.ref = forwardedRef;
  return React.createElement(DropdownItem, Object.assign({
    active: props.className ? props.className.includes("active") : false,
    disabled: props.disabled
  }, props));
});
export var ReactRouterActionItem = forwardRef(function (_props, forwardedRef) {
  var props = createReactRouterProps(_props);
  props.ref = forwardedRef;
  return React.createElement("li", {
    className: classNames("nav-icon-item", props.className)
  }, React.createElement("a", Object.assign({}, props, {
    className: classNames("nav-icon", {
      disabled: props.disabled
    })
  }), props.children));
});
export var ReactRouterSideNav = forwardRef(function (_props, forwardedRef) {
  var props = createReactRouterProps(_props);
  props.ref = forwardedRef;
  return React.createElement(NavItem, null, React.createElement(NavLink, Object.assign({}, props)));
});